module.exports = __webpack_public_path__ + "img/Glasses.c822308d.svg";